module.exports = __webpack_public_path__ + "img/logo.902ab0e7.png";